import {Branded, brand, number, string, union} from 'io-ts';

/**
 * Id should not be interpreted as string or number. The only purpose of id is to be comparable.
 * If we could make a normal value object from id it would have only one method `.isSameId(otherId)`
 * By making id a wider type we can restrict what methods can be called on it.
 */
const IdLike = union([number, string]);
type IdLike = number | string;

export const UserId = brand(IdLike, (n): n is UserId => true, 'UserId');

export type UserId = Branded<IdLike, UserIdBrand>;

interface UserIdBrand {
    readonly UserId: unique symbol;
}
